/**
 * Runtime configuration of the SPA, from Vite's build-time `VITE_*` variables.
 */
const required = (name: string, value: string | undefined): string => {
  if (!value) throw new Error(`${name} is not set`);
  return value;
};

export const SUPABASE_URL = required(
  "VITE_SUPABASE_URL",
  import.meta.env.VITE_SUPABASE_URL,
);
export const SUPABASE_PUBLISHABLE_KEY = required(
  "VITE_SUPABASE_PUBLISHABLE_KEY",
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
);
/** Backend origin, without trailing slash. Routes are addressed as `/api/...`. */
export const API_URL = required(
  "VITE_API_URL",
  import.meta.env.VITE_API_URL,
).replace(/\/+$/, "");

const STORAGE_PUBLIC_URL = `${SUPABASE_URL}/storage/v1/object/public`;
export const PROFILE_PICTURES_URL = `${STORAGE_PUBLIC_URL}/profiles_pictures`;
export const ORGANIZATIONS_LOGO_URL = `${STORAGE_PUBLIC_URL}/organizations_logo`;

/**
 * Absolute URL of an in-app route (OAuth `redirectTo`). The only place that
 * reads `window.location.origin`.
 */
export const appUrl = (path = ""): string =>
  `${window.location.origin}/${path.replace(/^\/+/, "")}`;
